import React from "react";
import {
  Form,
  message,
  Col,
  Row
} from "antd";
import { useForm } from "antd/lib/form/Form";
import { api } from "../api";
import axios from "axios";
import InputIcon from "../components/forms/inputIcon";
import FormButton from "../components/forms/button";
import InputPassword from '../components/forms/inputPassword';
import InputConfirmPassword from '../components/forms/inputConfirmPassword';
import { useNavigate } from "react-router-dom";

export default function SignUp() {
  const [form] = useForm();
  const Navigate = useNavigate();
  const loginUser = (value) => {
    axios.post(`${api}/users/signup.php`, JSON.stringify(value))
      .then(res => {
        if (res.data.status) {
          message.success(res.data.message)
          form.resetFields();
          Navigate('/users')
        }
        else {
          message.error(res.data.message)
        }
      })
      .catch(e => message.error('Something Went Wrong'))
  }

  return (
    <>
      <div className="layout-sign-up ">
        <Row justify="center">
            <Col span={12}>
                <Form
                name="basic"
                initialValues={{ remember: true }}
                onFinish={loginUser}
                className="row-col"
                form={form}
                >
                <h2 className="sub-heading text-center">Create Account</h2>
                    <Col span={24} className="input-div">
                        <InputIcon name='username' message='Email' type="email" />
                    </Col>
                    <Col span={24} className="input-div">
                        <InputPassword name='password' message='Password' type="string" />
                    </Col>
                    <Col span={24} className="input-div">
                        <InputConfirmPassword name='confirm_password' message='confirm Password' type="string" />
                    </Col>
                    <Row justify="center">
                        <Col span={8} >
                            <FormButton value="Submit" htmlType="submit" />
                        </Col>
                    </Row>
                   
                </Form>
            </Col>
        </Row>
         
      </div>
    </>
  );
}
